// extracted by mini-css-extract-plugin
export default {"img":"Photo_img__mQk0b"};